








import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapPreviewImgUrl } from '@gruppe-adler/maps-frontend-utils';
import { MapMetaData } from '@gruppe-adler/maps-frontend-utils';
import { PropType } from 'vue';

@Component
export default class GradMapItemVue extends Vue {
    @Prop({ required: true, type: Object as PropType<Pick<MapMetaData,'worldName'|'displayName'|'author'>> }) private map!: Pick<MapMetaData,'worldName'|'displayName'|'author'>;

    private get imageUrl(): string {
        return mapPreviewImgUrl(this.map.worldName, 256);
    }
}
